import React from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => (
  <article
    className="absolute h-9/12 flex justify-center items-center w-screen overflow-y-scroll text-white bg-black"
    aria-labelledby="privacy-title"
    tabIndex={0}
  >
    <div className="h-full w-full min-w-0 px-5 break-words sm:w-2/3 sm:px-0">
      <h1 id="privacy-title" className="text-xl sm:text-3xl my-5">
        Datenschutzerklärung
      </h1>
      <p className="italic my-5">
        Entwurf – vor Veröffentlichung zu vervollständigen. Dienstleister,
        Rechtsgrundlagen, Löschfristen und internationale Datenübermittlungen
        müssen noch bestätigt werden.
      </p>

      <h2 className="text-lg sm:text-xl mt-10 mb-5">
        1. Verantwortlicher und Kontakt
      </h2>
      <p className="my-5">
        Fahrschule Untern Buchen, André Zieroth, Eberswalde.
        <br />
        Eisenbahnstraße 31, 16225 Eberswalde, Deutschland.
        <br />
        E-Mail:{' '}
        <a className="text-yellow" href="mailto:kontakt@unternbuchen.de">
          kontakt@unternbuchen.de
        </a>
      </p>
      <p className="my-5">
        Bei Fragen zur Verarbeitung deiner Daten oder zur Ausübung deiner Rechte
        kannst du dich an uns wenden.
      </p>

      <h2 className="text-lg sm:text-xl mt-10 mb-5">
        2. Bereitstellung der Website
      </h2>
      <p className="my-5">
        Diese Website nutzt Firebase Hosting von Google. Beim Abruf werden
        technisch notwendige Verbindungsdaten, insbesondere die IP-Adresse,
        angeforderte Ressourcen und Browserinformationen, an den Hostingdienst
        übermittelt. Dies dient der Auslieferung und dem sicheren Betrieb der
        Website. Als Rechtsgrundlage kommt Art. 6 Abs. 1 lit. f DSGVO in
        Betracht (berechtigtes Interesse an einer sicheren, erreichbaren
        Website).
      </p>
      <p className="italic my-5">
        Noch zu ergänzen: vertraglicher Anbieter, Protokolldaten und deren
        Löschfristen, Auftragsverarbeitung sowie gegebenenfalls
        Drittlandtransfers und Garantien.
      </p>

      <h2 className="text-lg sm:text-xl mt-10 mb-5">
        3. Kontakt und Online-Anmeldung
      </h2>
      <p className="my-5">
        Wenn du uns kontaktierst, verarbeiten wir deine Kontaktdaten und deine
        Nachricht zur Bearbeitung deiner Anfrage. Bei vorvertraglichen Anfragen
        kommt Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage in Betracht.
      </p>
      <p className="my-5">
        Das Anmeldeformular fragt Name, Anschrift, Staatsangehörigkeit,
        Geburtsdatum, Telefonnummer, E-Mail-Adresse, gewünschte und vorhandene
        Führerscheinklassen sowie Angaben zum begleiteten Fahren und zur
        Sehhilfe ab. Nach dem Absenden werden die Angaben in Google Cloud
        Firestore gespeichert. Eine Serverfunktion ist für die Weiterleitung der
        Anmeldedaten per E-Mail an die Anmeldeverwaltung und weitere
        konfigurierte Empfänger eingerichtet; darunter befinden sich
        Gmail-Postfächer.
      </p>
      <p className="italic my-5">
        Vor Veröffentlichung prüfen: erforderliche und freiwillige Angaben,
        Empfängerkreis und E-Mail-Dienstleister, Speicherregionen, Löschfristen
        und Rechtsgrundlagen. Die Angabe zur Sehhilfe kann Gesundheitsdaten
        betreffen; hierfür ist zusätzlich eine passende Voraussetzung nach Art.
        9 DSGVO zu klären. Eine Karteneinwilligung deckt diese Verarbeitung
        nicht ab.
      </p>

      <h2 className="text-lg sm:text-xl mt-10 mb-5">
        4. Speicherung in deinem Browser
      </h2>
      <p className="my-5">
        Nicht abgesendete Formularangaben bleiben nur im Arbeitsspeicher der
        geöffneten Anmeldung. Sie werden weder in Local Storage noch in Session
        Storage gespeichert. Beim Neuladen oder Verlassen der Anmeldung gehen
        sie verloren. Nach erfolgreichem Absenden wird der Formularzustand
        geleert; die übermittelten Daten verbleiben gemäß Abschnitt 3 in der
        Anmeldeverarbeitung.
      </p>
      <p className="my-5">
        Frühere lokal gespeicherte Formularantworten werden nicht mehr genutzt.
        Du kannst sie über die Website-Daten in deinen Browsereinstellungen
        löschen. Dabei wird auch eine gespeicherte Karteneinwilligung entfernt;
        siehe Abschnitt 5.
      </p>

      <h2 className="text-lg sm:text-xl mt-10 mb-5">5. Google Maps</h2>
      <p className="my-5">
        Die Karte bleibt zunächst deaktiviert. Erst durch „Einwilligen und
        Google Maps laden“ wird Google Maps eingebunden. Dabei werden unter
        anderem IP-Adresse und Browserdaten an Google übermittelt; Google kann
        weitere Ressourcen laden und Informationen im Browser speichern oder
        auslesen. Eine Verarbeitung in den USA ist möglich. Grundlage für das
        freiwillige Laden ist deine Einwilligung gemäß Art. 6 Abs. 1 lit. a
        DSGVO und, soweit erforderlich, § 25 Abs. 1 TDDDG.
      </p>
      <p className="my-5">
        Deine Einwilligung wird im lokalen Browserspeicher (Local Storage)
        gespeichert. Bei weiteren Seitenaufrufen wird die Karte automatisch
        geladen, bis du die Einwilligung widerrufst oder die Website-Daten im
        Browser löschst. Ist die Speicherung im Browser gesperrt, gilt die
        Einwilligung nur bis zum Neuladen. Über „Einwilligung widerrufen und
        Seite neu laden“ an der Karte kannst du die gespeicherte Auswahl löschen
        und die Einwilligung zurücknehmen. Dies verhindert das erneute Laden,
        macht bereits erfolgte Übermittlungen aber nicht rückgängig und löscht
        keine bereits bei Google gespeicherten Daten. Kontaktdaten sind auch
        ohne Karte verfügbar.
      </p>
      <p className="my-5">
        <a
          className="text-yellow"
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Datenschutzhinweise von Google
        </a>
      </p>
      <p className="italic my-5">
        Noch zu bestätigen: verantwortlicher Google-Anbieter und anwendbare
        Grundlage sowie Garantien für Drittlandübermittlungen. Die Einwilligung
        in die Karte allein ersetzt diese Prüfung nicht.
      </p>

      <h2 className="text-lg sm:text-xl mt-10 mb-5">
        6. Schriftarten und Analyse
      </h2>
      <p className="my-5">
        Montserrat wird zusammen mit dieser Website ausgeliefert. Für die
        Seitenschrift ist kein Abruf vom Google-Fonts-Dienst erforderlich. Die
        Website initialisiert keine Firebase-/Google-Analytics-Messung. Eine
        aktivierte Google-Karte kann eigene externe Ressourcen nachladen.
      </p>

      <h2 className="text-lg sm:text-xl mt-10 mb-5">7. Deine Rechte</h2>
      <p className="my-5">
        Nach Maßgabe der DSGVO hast du Rechte auf Auskunft, Berichtigung,
        Löschung, Einschränkung der Verarbeitung und Datenübertragbarkeit. Bei
        Verarbeitung auf Grundlage berechtigter Interessen kannst du aus Gründen
        deiner besonderen Situation Widerspruch einlegen. Eine Einwilligung
        kannst du jederzeit mit Wirkung für die Zukunft widerrufen; die
        Rechtmäßigkeit der vorherigen Verarbeitung bleibt unberührt.
      </p>
      <p className="my-5">
        Du kannst dich bei einer Datenschutzaufsichtsbehörde beschweren,
        insbesondere an deinem Aufenthaltsort, Arbeitsplatz oder dem Ort des
        vermuteten Verstoßes. In Brandenburg ist dies die{' '}
        <a
          className="text-yellow"
          href="https://www.lda.brandenburg.de/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Landesbeauftragte für den Datenschutz und für das Recht auf
          Akteneinsicht
        </a>
        .
      </p>
      <p className="my-5">
        <Link className="text-yellow" to="/impressum">
          Zum Impressum
        </Link>
      </p>
    </div>
  </article>
);

export default Privacy;
